/* eslint-disable */
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { selectCurrentConfirm, setConfirm } from 'context/auth/authSlice';
import { Controller } from "react-hook-form";
import { Grid, InputAdornment, Icon, Tooltip  } from "@mui/material";
import ImageCropper from "dashboard/examples/Forms/easyCrop";
import { useUpdateDistributerPhotoMutation, useUpdateDistributerMutation, useDeleteDistributerPhotoMutation } from "context/distributer/distributerApiSlice";
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDButton from "dashboard/components/MDButton";
import MDAvatar from "dashboard/components/MDAvatar";
import MDAlert from "dashboard/components/MDAlert";
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTube from '@mui/icons-material/YouTube';
import useAlert from 'hooks/useAlert';

const SencondStep = ( props ) => {

    const { register, control, distributer, setValue  } = props;
    const dispatch = useDispatch();
    const confirmStatus = useSelector(selectCurrentConfirm);
    const {showAlerts} = useAlert();
    const [distributerPhoto, setDistributerPhoto] = useState('');
    const [distributerPhotoList, setDistributerPhotoList] = useState([]);
    const [deleteDistributerPhoto] = useDeleteDistributerPhotoMutation();
    const [errorMsg, setErrorMsg] = useState("");
    const [UpdatePhoto, {isLoading : loadingUp , error : errorUpload }] = useUpdateDistributerPhotoMutation();
    const [UpdateDistributer] = useUpdateDistributerMutation();

    useEffect(() => {
      setDistributerPhoto(distributer?.selectedImage);
      setDistributerPhotoList(distributer.photos);
    }, [distributer]);

    const onDelete = async item =>{
      if(item === distributerPhoto.split('/').pop()) {
          return showAlerts({code:"info", icon:"info", title : "Delete Distributer photo", msg : "Your are using this picture !", type : "toast"});
      }
      showAlerts({code:"warning", icon:"warning", title : "Delete Distributer photo", msg : "Are you sure you want to delete this image ?  ", type : "confirm", action: item});
    }

    const onConfirmDelete = async item =>{
        const data ={
        name : item,
        category : distributer.category?.category,
        id : distributer.id
        };

        try{
          const response = await deleteDistributerPhoto(data).unwrap();
          showAlerts({code:"success", title : "Delete Distributer photo", msg : response.message, type : "toast"});
          const newList = distributerPhotoList.filter( item => item.name !== data.name);
          setValue('photos', newList);
          setDistributerPhotoList(newList);
        }catch (error){
          showAlerts({code:"error", title : "Delete Distributer photo", msg : error?.data?.error, type : "toast"});
        }
        dispatch(setConfirm({type:null, data:null}))
    }
    useEffect(() => {
      confirmStatus.type === "DistributerPhoto" ? onConfirmDelete(confirmStatus.data) : null
    }, [confirmStatus])
    
    const UpdateFunction = async update => {
        try{
          const userData = await UpdateDistributer({filter: {id:distributer?.id}, update}).unwrap();
          showAlerts({code:"success", msg : userData.message, title: "Distributer update " ,type : "toast"});
          if(update?.hasOwnProperty('selectedImage')) setDistributerPhoto(update.selectedImage); 
          setErrorMsg("");
        } catch(err) {  
            setErrorMsg(`${err.data.error}`); // onSubmit
        }
    }

    const selectThisImg = (item,path) =>{
        if(item === distributer?.selectedImage.split('/').pop()) {
            return showAlerts({code:"info",icon:"info", title : "Change Distributer photo", msg : "Your are using this picture !", type : "toast"});
        }
        UpdateFunction({selectedImage:path})
    }

    const handleUpload = async formData =>{
        formData.append("id",distributer?.id);
        formData.append("category",distributer.category?.category);
        const uploadResponse = await UpdatePhoto(formData);
        if(uploadResponse.data?.status === "success"){
          setValue('photos',[...distributerPhotoList,uploadResponse.data.distributer]);
          setValue('selectedImage',uploadResponse.data.distributer.path);
          setDistributerPhotoList([...distributerPhotoList,uploadResponse.data.distributer])
          setDistributerPhoto(uploadResponse.data.distributer.path);
        }
        return uploadResponse;
    }
    
  return (
     
    <Grid container  spacing={{ xs: 1, md: 2 }} p={2} >
        <Grid xs={12} sx={{textAlign:"center"}} item>
            {errorMsg  && <MDAlert color="error"><small style={{ fontSize:"12px",whiteSpace: "normal" }}> {errorMsg} </small></MDAlert> }
        </Grid>
        <Grid lg={6} sx={{textAlign:"center"}} item>
        <ImageCropper handleUpload={handleUpload} isLoading={loadingUp} errorUpload={errorUpload}  profilImage={`${process.env.REACT_APP_PUBLIC_URL}/img/distributer/${distributerPhoto}`} />
        <MDTypography variant="caption">Distributer photos : <span style={{color : 'initial'}}>{distributerPhotoList.length}</span></MDTypography>
            <MDBox p={.5} sx={{maxHeight:"400px", overflowY:"scroll"}}>  
                  {distributerPhotoList?.map(image => {                
                    return (<Grid key={image.name} justifyItems="center" justifyContent="center"  sx={{ border:'.1em dashed #eaeaea', p:.5, borderRadius:1.6, my:.5 }} container>
                    <Grid xs={2} item>
                        <MDAvatar src={`${process.env.REACT_APP_PUBLIC_URL}/img/distributer/${image.path}`} alt={image.name} />
                    </Grid>
                      <Grid xs={8} sx={{alignSelf:"center"}}  textAlign="left" item>
                        <Tooltip title="Click to select this image as a distributer picture" placement="top">
                          <MDButton variant="text" sx={{px:1}} onClick={()=>selectThisImg(image.name,image.path)}>
                            <MDTypography noWrap  variant="caption">{image.name}</MDTypography>
                          </MDButton>
                        </Tooltip>
                      </Grid>
                      <Grid xs={2} sx={{alignSelf:"center"}} item>
                        <MDButton variant="outlined" color="secondary"  sx={{minHeight:35, minWidth:35, p:.5}}  onClick={()=>onDelete(image.name)}><Icon size="medium">close</Icon></MDButton>
                      </Grid>
                    </Grid>)
                  }).reverse()
                  }
            </MDBox>
        </Grid>
        <Grid xs={12} lg={6}  item>
          <Controller name="social.fb" control={control} 
              render={({ field: { onChange, value } }) => (
                <MDInput multiline  name="fb" value={value}
                  {...register("social.fb", { required: false })}
                  placeholder="Enter your facebook distributer link" 
                  onChange={onChange} size="small" sx={{mb:1}}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment sx={{ml:1 , color:`#344767 !important`}} position="start">
                             <FacebookIcon/>
                        </InputAdornment>
                  )}}
                  fullWidth />
              )}
          />
          <Controller name="social.insta" control={control} 
              render={({ field: { onChange, value } }) => (
                <MDInput multiline  name="social.insta" value={value}
                {...register("social.insta", { required: false })}
                  placeholder="Enter your instagram distributer link" 
                  onChange={onChange} size="small" sx={{mb:1}}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment sx={{ml:1 , color:"#125688"}} position="start">
                             <InstagramIcon/>
                        </InputAdornment>
                  )}}
                  fullWidth />
              )}
          />
          <Controller name="social.tweet" control={control} 
              render={({ field: { onChange, value } }) => (
                <MDInput multiline  name="social.tweet" value={value}
                {...register("social.tweet", { required: false })}
                  placeholder="Enter your twitter distributer link" 
                  onChange={onChange} size="small" sx={{mb:1}}
                  InputProps={{
                    startAdornment: (
                        <InputAdornment sx={{ml:1, color:"#55acee"}} position="start">
                            <TwitterIcon/>
                        </InputAdornment>
                  )}}
                  fullWidth />
              )}
            />
          <Controller name="social.ytube" control={control} 
              render={({ field: { onChange, value } }) => (
                <MDInput multiline  name="social.ytube" value={value}
                  {...register("social.ytube", { required: false })}
                  placeholder="Enter your youtube distributer link" 
                  onChange={onChange} size="small"
                  InputProps={{
                    startAdornment: (
                        <InputAdornment sx={{ml:1, color:"#e52d27"  }} position="start">
                             <YouTube/>
                        </InputAdornment>
                  )}}
                  fullWidth />
              )}
            />
        </Grid>
    </Grid>
  )
}

export default SencondStep